import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Skeleton } from "@/components/ui/skeleton"; // Import Skeleton for loading state
import { authClient } from "@/lib/auth-client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: session, isPending } = authClient.useSession();

  useEffect(() => {
    // Redirect to dashboard if logged in and session is loaded
    if (!isPending && session) {
      navigate("/dashboard", { replace: true }); // Use replace to avoid back button issues
    }
  }, [session, isPending, navigate]);

  // Show loading indicator while checking session
  if (isPending || session) {
    // Also show loading if session exists, as redirect is imminent
    return (
      <div className="flex flex-col gap-6 p-4 md:p-6">
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-1/2" />
          </CardHeader>
          <CardContent className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
          </CardContent>
        </Card>
      </div>
    );
  }

  // Render home content only if not pending and not logged in
  return (
    <div className="flex flex-col gap-6 p-4 md:p-6"> {/* Add padding */}
      <Card>
        <CardHeader>
          <CardTitle>{t("home.title")}</CardTitle>
        </CardHeader>
        <CardContent>
          <p>{t("home.content1")}</p>
          <p>{t("home.content2")}</p>
        </CardContent>
      </Card>
    </div>
  );
}

export default HomePage;
